@if (subCategory?.id && configLoaded && (!firstLoad || isReady)) { @if
(taxReturn.snapshot) {
<app-snapshot-banner
  [snapshot]="taxReturn.snapshot"
  [status]="taxReturn.fullStatus"
>
</app-snapshot-banner>
} @if (taxReturn.mandatoryIncompleteClientRulesCount) {
<app-message-banner
  type="WARNING"
  [hidden]="!!taxReturn.snapshot"
  [message]="getClientRulesWarning()"
>
</app-message-banner>
}
<header id="header-container" [ngClass]="{ 'full-screen': isFullScreenMode }">
  <div id="header-details">
    <div id="header-title">
      <h4>
        <span
          [routerLink]="[
            '/',
            uiConfig?.config?.taxReturnAliasPath,
            taxReturn?.id
          ]"
          [queryParams]="{
            category: categoryName | lowercase | cleanElementSelector,
            isGlobal: subCategory.isGlobal
          }"
        >
          &lt;&lt; {{ taxReturn?.firstName }} {{ taxReturn?.lastName }}
        </span>
        <span class="client">{{
          (taxReturn?.assignee?.populations)[0]?.client?.name
        }}</span>
        @if (isFullScreenMode) {
        <span class="bread-crumb-a">
          {{ subCategory?.name }}
        </span>
        <span class="bread-crumb-b">
          {{ fullScreenSubGroup?.name }}
        </span>
        }
      </h4>
      @if (!isFullScreenMode) {
      <h1>
        {{ subCategory?.name }}
      </h1>
      }
    </div>
    @if (!isFullScreenMode) {
    <div id="header-notifications">
      @if (isAdmin) {
      <div style="margin-right:1em" class="empty-questions-toggle">
        <div style="flex:1"></div>
        <div
          class="ui slider checkbox"
          title="Hide questions which don't contain any answers, warnings, flags and comments"
        >
          <input
            [formControl]="debugModeControl"
            type="checkbox"
            class="hidden"
          />
          <label>{{ "taxReturns.debug" | transloco }}</label>
        </div>
      </div>
      } @if (taxReturn.docshareRootFolder) {
      <a
        class="notification-icon documents-highlighted"
        [href]="taxReturn.docshareRootFolder"
        target="_blank"
        rel="noreferrer"
      >
        <span class="count">{{ countDocuments(true) }}</span>
      </a>
      }
      <span (click)="showNotes()" class="notification-icon notes-highlighted">
        <span class="count">{{ subCategory.notesCount }}</span>
      </span>
      @if (!taxReturn.docshareRootFolder) {
      <span class="notification-icon documents-highlighted">
        <span class="count">{{ countDocuments(true) }}</span>
      </span>
      }
      <span class="notification-icon warnings-highlighted">
        <span class="count">{{ activeAnsWarnings(true) }}</span>
      </span>
      <span class="notification-icon flags-highlighted">
        <span class="count">{{ activeAnsFlags(true) }}</span>
      </span>
      <span class="notification-icon comments-highlighted">
        <span class="count">{{ commentsCount }}</span>
      </span>
      <span class="notification-icon review-highlighted">
        <span class="count">{{
          closedAnsFlags(true) + closedAnsWarnings(true) + commentsCount
        }}</span>
      </span>
      <div
        (click)="saveCheckEdits()"
        class="ui primary button"
        [ngClass]="{ loading: isSaving, hidden: readonly() }"
      >
        {{ "taxReturns.save" | transloco }}
      </div>
      <div
        (click)="runCalcs()"
        class="ui primary button"
        [ngClass]="{
          loading: isRunningCalcs,
          disabled:
            isSyncingAps ||
            isRunningCalcs ||
            isClearingOverrides ||
            commentFields.length > 0 ||
            (isLodged && disableRunCalcForLodgedTaxReturn)
        }"
      >
        {{ "taxReturns.run-calcs" | transloco }}
      </div>
      @if (config.featureFlags.aps) {
      <div
        (click)="syncAps()"
        class="ui primary button"
        [ngClass]="{
          loading: isSyncingAps,
          disabled:
            isSyncingAps ||
            isRunningCalcs ||
            isClearingOverrides ||
            commentFields.length > 0
        }"
      >
        {{ "taxReturns.sync-aps" | transloco }}
      </div>
      }
      <div class="override-select">
        <form [formGroup]="overRideForm">
          <select
            [disabled]="disableClearOverRides()"
            class="form-control"
            formControlName="overRide"
            [(ngModel)]="overRideFlag"
            (change)="updateOverRideFlag()"
            class="form-control"
          >
            <option
              hidden
              [disabled]="disableClearOverRides()"
              value=""
              selected
              >{{ "taxReturns.clear-overrides" | transloco }}</option
            >
            <option
              [disabled]="disableClearOverRides()"
              value="CLEAR SUBCATEGORY"
              >{{ "taxReturns.clear-subcategory" | transloco }}</option
            >
            <option
              [disabled]="disableClearOverRides()"
              (click)="showSingleAnswerOverRideModal()"
              value="SINGLE ANSWER"
              >{{ "taxReturns.single-answer" | transloco }}</option
            >
          </select>
        </form>
      </div>
    </div>
    }
  </div>
  @if (hasGroupings) {
  <div id="tabs-menu" class="no-select">
    @for (group of subCategory?.groups; track group; let index = $index) {
    <div
      (click)="gotoGroup(index)"
      class="tab"
      [ngClass]="{
        active: group?.id === activeGroup?.id,
        deleted: group.deleted,
        empty: !(group?.formGroup?.value)[group?.question?.id]
      }"
    >
      @if (group?.formGroup) {
      <div>
        <span class="tab-name">{{
          group.deleted
            ? group.deletedName
            : (group?.formGroup?.value)[group?.question?.id] || "empty"
        }}</span>
        @if (group?.notificationsCount > 0) {
        <span>({{ group?.notificationsCount }})</span>
        }
        <div
          (click)="allowEditGroupName(group) && showEditGroupName(group)"
          class="edit icon"
          [ngClass]="{ visible: allowEditGroupName(group) }"
        ></div>
        <div
          (click)="allowDeleteGroup(group) && showDeleteGroupModal(group)"
          class="delete icon"
          [ngClass]="{ visible: allowDeleteGroup(group) }"
        ></div>
      </div>
      }
    </div>
    } @if (!readonly()) {
    <div (click)="showAddGroupModal()" class="add icon"></div>
    }
  </div>
  }
</header>
<div id="body-content" [ngClass]="{ 'full-screen': isFullScreenMode }">
  @for (group of subCategory?.groups; track group; let groupIndex = $index) {
  @if (activeGroupsSelected[group?.id]) {
  <div
    #scrollContainer
    (scroll)="onScroll($event)"
    [hidden]="group?.id !== activeGroup?.id"
    class="question-cards-container hidden-scrollbar"
    [ngClass]="{ deleted: group?.deleted }"
    (clickOutside)="deselectCard(groupIndex)"
    [clickOutsideEvents]="'mousedown'"
    [clickOutsideExclude]="'.subcategory-right-panel'"
  >
    @if (!isFullScreenMode) {
    <div class="empty-questions-toggle">
      <div style="flex:1"></div>
      <div
        class="ui slider checkbox"
        title="Hide questions which don't contain any answers, warnings, flags and comments"
      >
        <input
          [formControl]="group.uiControls.controls['hideEmptyQuestions']"
          type="checkbox"
          tabindex="0"
          class="hidden"
        />
        <label>{{ "taxReturns.hide-empty-questions" | transloco }}</label>
      </div>
    </div>
    } @for (subGroup of group?.subgroups; track subGroup) { @if
    (!subGroup.hidden) {
    <app-question-group-card
      [modernTableScrollUp]="modernTableScrollUp"
      [tableScrollContainerRefUp]="tableScrollContainerRefUp"
      (tableScroll)="onTableScroll($event, subGroup.id)"
      (modernTableScroll)="handleScroll($event, subGroup.id)"
      (modernTableScrollRefEmitter)="
        onModernTableScrollRefEmit($event, subGroup.id)
      "
      [hidden]="isFullScreenMode && fullScreenSubGroup.id !== subGroup.id"
      [formGroup]="group.deleted ? group.deletedFormGroup : group?.formGroup"
      [subGroup]="subGroup"
      [groupId]="group.id"
      [isActive]="activeGroup?.activeSubGroup?.id === subGroup.id"
      [deleted]="group.deleted"
      [isVisible]="activeGroup?.id === group?.id"
      [readonly]="readonlyAlwaysEditableQuestion()"
      [inspectMode]="
        (rightSideTab == 'calculation' && 'trace') ||
        (tab == 3 && 'flag') ||
        (tab == 5 && 'review') ||
        null
      "
      [modernTable]="modernTable"
      [isFullScreenMode]="isFullScreenMode"
      [fullScreenSubGroup]="fullScreenSubGroup"
      [chartRequested]="chartRequested"
      (toggleFullScreen)="handleToggleFullScreen($event)"
      (handleAside)="handleSideOpen($event)"
      [sideOpen]="sideOpen"
      [debugMode]="debug"
      [taxReturnId]="taxReturn.id"
      [labelClick]="answerSelected"
      [hideEmptyQuestions]="
        group.uiControls.controls['hideEmptyQuestions'].value
      "
      [hideClearOverRideQuestionIcon]="hideOverrideIcon()"
      (refreshTaxReturn)="refreshTaxReturn()"
      (loadTrace)="loadTrace($event)"
      (selectSubgroup)="selectSubgroup(subGroup)"
      [inputQuestionId]="inputQuestionId"
      [isCollapsed]="subGroup.isCollapsed"
      (setCollapsedState)="setCollapsedState($event)"
      (addNewRowAdded)="newRow($event)"
    >
    </app-question-group-card>
    } }
  </div>
  } }
  <aside class="subcategory-right-panel" [ngClass]="{ closed: !sideOpen }">
    <i
      class="toggle-side chevron icon"
      [ngClass]="{ right: sideOpen, left: !sideOpen }"
      (click)="handleSideOpen()"
    ></i>
    <div class="right-side-tab-selector">
      <div
        class="right-side-tab"
        [ngClass]="{ active: rightSideTab == 'activity' }"
        (click)="rightSideTab = 'activity'"
      >
        {{ "taxReturns.activity" | transloco }}
      </div>
      <div
        class="right-side-tab"
        [ngClass]="{ active: rightSideTab == 'calculation' }"
        (click)="rightSideTab = 'calculation'"
      >
        {{ "taxReturns.calculation" | transloco }}
      </div>
    </div>
    @if (rightSideTab == 'calculation' && traceQuestion) {
    <h3 class="calculation-header">
      @if (showQuestionId) {
      <span>{{ traceQuestion?.id }}.</span>
      }
      {{ traceQuestion.question }}
    </h3>
    } @if (rightSideTab == 'calculation') {
    <div class="tab-content calculation-tab">
      @if (loadingTrace) {
      <div class="ui active centered inline loader"></div>
      } @if (!loadingTrace && !traceQuestion) {
      <div class="trace-message">
        {{
          "taxReturns.click-a-question-label-or-table-cell-to-view-how-an-answer-was-calculated"
            | transloco
        }}
      </div>
      }
      <app-answer-trace
        [trace]="trace"
        [question]="traceQuestion"
        [answer]="traceAnswer"
        [taxReturn]="taxReturn"
        [subCategory]="subCategory"
        [activeGroup]="activeGroup"
      ></app-answer-trace>
    </div>
    } @if (rightSideTab == 'activity') {
    <div class="tab-content activity-tab">
      <div id="notifications">
        <h3 id="title">
          {{ title() }}
        </h3>
        <div id="icons">
          <div
            (click)="filterDocuments(); selectTab(4)"
            class="notification-icon documents-highlighted"
            [ngClass]="{ active: tab == 4 }"
          >
            <span class="count">{{ countDocuments() }}</span>
          </div>
          <div
            (click)="initWarnings(); selectTab(1)"
            class="notification-icon warnings-highlighted"
            [ngClass]="{ active: tab == 1 }"
          >
            <span class="count">{{ activeAnsWarnings() }}</span>
          </div>
          <div
            (click)="initFlagsTab(); selectTab(3)"
            class="notification-icon flags-highlighted"
            [ngClass]="{ active: tab == 3 }"
          >
            <span class="count">{{ activeAnsFlags() }}</span>
          </div>
          <div
            (click)="selectTab(2)"
            class="notification-icon comments-highlighted"
            [ngClass]="{ active: tab == 2 }"
          >
            <span class="count">{{ totalComments }}</span>
          </div>
          <div
            (click)="initFlagsTab(); selectTab(5)"
            class="notification-icon review-highlighted"
            [ngClass]="{ active: tab == 5 }"
          >
            <span class="count">{{
              closedAnsFlags(false) + closedAnsWarnings(false) + commentsCount
            }}</span>
          </div>
        </div>
      </div>
      @if (tab === 1) {
      <div id="warnings-tab">
        <div class="list-container">
          <div style="flex:1"></div>
          @for (answerWarning of answerWarnings; track answerWarning) {
          <div>
            @if (answerWarning?.status === 0) {
            <div
              class="warning"
              [ngClass]="{ disabled: answerWarning?.status !== 0 }"
            >
              <div class="header">
                <div class="warning-type">
                  <div class="ui orange label">
                    {{ "taxReturns.review" | transloco }}
                  </div>
                  {{ answerWarning?.warning?.message }}
                </div>
                <div class="warning-date">
                  {{ answerWarning?.createdAtString }}
                </div>
              </div>
              <div class="labels">
                <span
                  class="ui label"
                  (click)="
                    setfocusOnQuestion(
                      answerWarning?.questionId,
                      'warning',
                      answerWarning?.answerId
                    )
                  "
                >
                  @if (showQuestionId) {
                  <span>{{ answerWarning?.questionId }}.</span>
                  }
                  {{ answerWarning?.question }}
                  @if (answerWarning?.rowIndex) {
                  <span> (row - {{ answerWarning?.rowIndex }})</span>
                  }</span
                >
              </div>
              <pre class="warning-message">{{
                answerWarning?.warningMessage
              }}</pre>
              @for (comment of answerWarning.replies; track comment) {
              <div class="comment">
                <div class="commenter-name">{{ comment?.author }}</div>
                <div class="commenter-role">
                  <div>
                    <i
                      class="small circle icon"
                      [ngClass]="{
                        preparer: comment?.role === 'Preparer',
                        reviewer: comment?.role === 'Reviewer'
                      }"
                    ></i>
                    {{ comment?.role }}
                  </div>
                  <div class="comment-date">{{ comment?.date }}</div>
                </div>
                <div class="comment-text">
                  <app-comment
                    [comment]="comment"
                    [documents]="taxReturn.documents"
                    (imgClick)="setModal($event)"
                  ></app-comment>
                </div>
              </div>
              }
              <div class="reply-comment">
                @if (answerWarning?.replyTo) {
                <div>
                  <app-attachments
                    [(ngModel)]="answerWarning.replyComment"
                    (setModal)="setModal($event)"
                  ></app-attachments>
                  <span
                    (click)="cancelReply(answerWarning)"
                    class="cancel-reply"
                    >{{ "taxReturns.cancel" | transloco }}</span
                  >
                  <span
                    (click)="
                      commentFields?.length === 0 &&
                        (answerWarning.replyComment.message ||
                          !replyingWarning) &&
                        countInputWarnings(
                          answerWarning,
                          answerWarning.replyComment,
                          false
                        )
                    "
                    [ngClass]="{
                      disabled:
                        !answerWarning.replyComment.message || replyingWarning
                    }"
                    class="reply-only"
                    [class.disabled]="commentFields?.length > 0"
                    [attr.data-tooltip]="
                      commentFields?.length > 0
                        ? ('taxReturns.save-inputs-first' | transloco)
                        : null
                    "
                    [attr.data-position]="'left center'"
                    [attr.data-variation]="'black'"
                    >{{ "taxReturns.reply-only" | transloco }}</span
                  >
                  <div
                    (click)="
                      commentFields?.length === 0 &&
                        (answerWarning.replyComment.message ||
                          !replyingWarning) &&
                        countInputWarnings(
                          answerWarning,
                          answerWarning.replyComment,
                          true
                        )
                    "
                    class="respond-close"
                    [class.disabled]="commentFields?.length > 0"
                    [attr.data-tooltip]="
                      commentFields?.length > 0
                        ? ('taxReturns.save-inputs-first' | transloco)
                        : null
                    "
                    [attr.data-position]="'left center'"
                    [attr.data-variation]="'black'"
                    [ngClass]="{
                      disabled:
                        !answerWarning.replyComment.message || replyingWarning
                    }"
                  >
                    {{ "taxReturns.reply-and-close" | transloco }}
                  </div>
                </div>
                }
              </div>
              <div class="buttons">
                @if (answerWarning?.status == 0 && !answerWarning?.replyTo &&
                !readonly()) {
                <div
                  (click)="
                    commentFields?.length === 0 &&
                      (answerWarning.replyTo = true)
                  "
                  class="respond"
                  [class.disabled]="commentFields?.length > 0"
                  [attr.data-tooltip]="
                    commentFields?.length > 0
                      ? ('taxReturns.save-inputs-first' | transloco)
                      : null
                  "
                  [attr.data-position]="'top left'"
                  [attr.data-variation]="'black'"
                >
                  {{ "taxReturns.reply" | transloco }}
                </div>
                } @if (showSendToClientButton(answerWarning)) {
                <div class="send-to-client">
                  <i class="arrow up icon"></i>
                  <span>{{ "taxReturns.Send-to-Client" | transloco }}</span>
                </div>
                }
                <!-- <div *ngIf="answerWarning.externalUrl"  class="view-in-oneteam">
                                          <i class="external alternate icon"></i> <span>{{ 'taxReturns.View-in-OneTeam' | transloco }}</span>
                                        </div> -->
                <div></div>
              </div>
            </div>
            }
          </div>
          }
          <ng-template #criticalWarning let-warnings="warnings">
            @for (warning of warnings; track warning) {
            <div>
              <div class="warning">
                <div class="header">
                  <div class="warning-type">
                    <div class="ui red label">
                      {{ "taxReturns.critical" | transloco }}
                    </div>
                    {{ warning?.warningMessage }}
                  </div>
                  <div class="warning-date">
                    {{ warning?.createdAtString }}
                  </div>
                </div>
                <div class="labels">
                  <span
                    (click)="
                      setfocusOnQuestion(
                        warning?.id,
                        'warning',
                        warning?.answerId
                      )
                    "
                    class="ui label"
                  >
                    @if (showQuestionId) {
                    <span>{{ warning?.id }}.</span>
                    }
                    {{ warning?.question }}</span
                  >
                </div>
              </div>
            </div>
            }
          </ng-template>
          @if (activeGroup?.activeSubGroup) {
          <ng-container
            *ngTemplateOutlet="
              criticalWarning;
              context: {
                warnings: activeGroup?.activeSubGroup?.validationWarnings
              }
            "
          >
          </ng-container>
          } @if (!activeGroup?.activeSubGroup) {
          <ng-container
            *ngTemplateOutlet="
              criticalWarning;
              context: { warnings: activeGroup?.validationWarnings }
            "
          >
          </ng-container>
          }
        </div>
      </div>
      } @if (tab === 3) {
      <div id="flags-tab">
        <div class="list-container">
          <div style="flex:1"></div>
          @for ( answerFlag of answerFlagsFiltered | orderBy:
          ['createdAt']:['asc'] ; track answerFlag) {
          <div class="flag" [ngClass]="{ disabled: answerFlag?.status > 0 }">
            @if (answerFlag?.status === 0 ) {
            <div class="comment">
              <div class="header">
                <div class="ui label">
                  {{ answerFlag.flag.flagMessage }}
                </div>
                <div class="commenter-name">
                  {{ answerFlag?.parentComment?.author }}
                </div>
                <div class="date">{{ answerFlag?.parentComment?.date }}</div>
              </div>
              <div class="commenter-role">
                <div>
                  <i
                    class="small circle icon"
                    [ngClass]="{
                      preparer: answerFlag?.parentComment?.role === 'Preparer',
                      reviewer: answerFlag?.parentComment?.role === 'Reviewer'
                    }"
                  ></i>
                  {{ answerFlag?.parentComment?.role }}
                </div>
                <div class="comment-date">
                  {{ answerFlag?.parentComment?.createdAtString }}
                </div>
              </div>
              <div class="labels">
                <div
                  class="ui label"
                  attr.data-content="{{ answerFlag?.groupName }}{{
                    answerFlag?.groupName && answerFlag?.subGroupName
                      ? ' - '
                      : ''
                  }}{{ answerFlag?.subGroupName }}{{
                    answerFlag?.rowIndex != null
                      ? ' - row ' + (answerFlag?.rowIndex + 1)
                      : undefined
                  }}"
                  title="{{ answerFlag?.groupName }}{{
                    answerFlag?.groupName && answerFlag?.subGroupName
                      ? ' - '
                      : ''
                  }}{{ answerFlag?.subGroupName }}{{
                    answerFlag?.rowIndex != null
                      ? ' - row ' + (answerFlag?.rowIndex + 1)
                      : undefined
                  }}"
                >
                  <span
                    (click)="
                      setfocusOnQuestion(
                        answerFlag?.question?.id,
                        'flag',
                        answerFlag?.answerId
                      )
                    "
                  >
                    @if (showQuestionId) {
                    <span>{{ answerFlag?.question?.id }}.</span>
                    }
                    {{ answerFlag?.question?.question }}</span
                  >
                </div>
              </div>
              @if (answerFlag.parentComment) {
              <div class="comment-text">
                <app-comment
                  [comment]="answerFlag.parentComment"
                  [documents]="taxReturn.documents"
                  (imgClick)="setModal($event)"
                ></app-comment>
              </div>
              } @for (comment of answerFlag?.parentComment?.comments; track
              comment) {
              <div class="reply comment">
                <div class="header">
                  <div class="commenter-name">{{ comment?.author }}</div>
                  <div class="date">{{ comment?.date }}</div>
                </div>
                <div class="commenter-role">
                  <div>
                    <i
                      class="small circle icon"
                      [ngClass]="{
                        preparer: comment?.role === 'Preparer',
                        reviewer: comment?.role === 'Reviewer'
                      }"
                    ></i>
                    {{ comment?.role }}
                  </div>
                </div>
                <div class="comment-text">
                  <app-comment
                    [comment]="comment"
                    [documents]="taxReturn.documents"
                    (imgClick)="setModal($event)"
                  ></app-comment>
                </div>
              </div>
              }
              <div class="reply-comment">
                @if (!readonly() && answerFlag.replyTo) {
                <div>
                  <app-attachments
                    [(ngModel)]="answerFlag.replyComment"
                    (setModal)="setModal($event)"
                  ></app-attachments>
                  <span
                    (click)="cancelReply(answerFlag)"
                    class="cancel-reply"
                    >{{ "taxReturns.cancel" | transloco }}</span
                  >
                  <span
                    (click)="replyToFlag(answerFlag)"
                    class="reply-only"
                    [ngClass]="{
                      disabled: !answerFlag.replyComment.message || replyingFlag
                    }"
                    >{{ "taxReturns.reply-only" | transloco }}</span
                  >
                  <div
                    (click)="replyToFlag(answerFlag, true)"
                    class="ui primary background button"
                    [ngClass]="{
                      disabled: !answerFlag.replyComment.message || replyingFlag
                    }"
                  >
                    {{ "taxReturns.reply-and-close" | transloco }}
                  </div>
                </div>
                }
              </div>
            </div>
            }
            <div class="buttons">
              @if ( !readonly() && answerFlag?.status === 0 &&
              !answerFlag.replyTo ) {
              <span (click)="answerFlag.replyTo = true" class="respond">{{
                "taxReturns.reply" | transloco
              }}</span>
              } @if (showSendToClientButton(answerFlag)) {
              <div class="send-to-client">
                <i class="arrow up icon"></i>
                <span>{{ "taxReturns.Send-to-Client" | transloco }}</span>
              </div>
              }
              <!-- <div *ngIf="answerFlag.externalUrl" class="view-in-oneteam">
                                            <i class="external alternate icon"></i> <a [href]="answerFlag.externalUrl" target="_blank">{{ 'taxReturns.View-in-OneTeam' | transloco }}</a>
                                          </div> -->
            </div>
          </div>
          }
          <div class="scroll-anchor"></div>
        </div>
        <div [hidden]="!flaggedAns" class="textbox-container">
          <div class="fields-title">
            <div class="label">
              {{ "taxReturns.flagged-fields" | transloco }}
            </div>
            <div class="line"></div>
          </div>
          <div class="fields-container">
            <div class="ui label">
              @if (showQuestionId) {
              <span>{{ (flaggedAns?.answers)[0]?.questionId }}.</span>
              }
              {{ flaggedAns?.question }} ({{ flaggedAns?.groupName }}@if
              (flaggedAns?.groupName && flaggedAns?.subGroupName) {
              <span> - </span>
              }{{ flaggedAns?.subGroupName }}@if (flaggedAns?.rowIndex != null)
              {
              <span
                >{{ "taxReturns.row" | transloco }}
                {{ flaggedAns?.rowIndex + 1 }}</span
              >
              })
              <i
                (click)="unFlagAns(flaggedAns)"
                class="close icon"
                title="Click to un-flag answer"
              ></i>
            </div>
          </div>
          <app-attachments
            id="flags-textbox"
            [formControl]="flagsComment"
            (setModal)="setModal($event)"
          ></app-attachments>
          <div style="display:flex; justify-content: flex-end;">
            @if (!config.featureFlags.standardFlagAsDefault) {
            <div #flagDropDown class="ui search selection dropdown">
              <input class="search" autocomplete="off" />
              <div class="text"></div>
              <div class="menu"></div>
              <i class="chevron down icon"></i>
            </div>
            } @if (!readonly()) {
            <div
              (click)="saveAnsFlag()"
              id="save-ans-flags"
              class="ui primary background button"
              [ngClass]="{
                disabled:
                  !flagsComment.value.message || !flagTypeId || isSaving,
                loading: isSaving
              }"
              [title]="
                !flagsComment.value.message
                  ? 'You must provide a comment'
                  : undefined
              "
            >
              {{ "taxReturns.post-flag" | transloco }}
            </div>
            }
          </div>
        </div>
      </div>
      } @if (tab === 4) {
      <div id="documents-tab">
        @if (filteredDocuments.length === 0) {
        <span class="no-docs">{{
          "taxReturns.no-documents-links-found" | transloco
        }}</span>
        }
        <ol>
          @for (doc of filteredDocuments; track doc) {
          <li>
            <a [href]="doc.url | KExplorer" target="_blank" rel="noreferrer">{{
              doc.filename || doc.url
            }}</a>
          </li>
          }
        </ol>
      </div>
      } @if (tab === 5) {
      <div id="review-tab">
        <div class="list-container">
          <div style="flex:1"></div>
          @for (reviewItem of combinedReviewItems | orderBy:
          ['updatedAt']:['asc']; track reviewItem) {
          <div
            [ngClass]="{
              warning: reviewItem.type === 'warning',
              flag: reviewItem.type === 'flag',
              comment: reviewItem.type === 'comment'
            }"
          >
            <div class="header">
              <!-- Labels for warnings -->
              @if (reviewItem.type === 'warning') {
              <div class="warning-type">
                <div class="ui orange label">
                  {{ "taxReturns.review" | transloco }}
                </div>
                {{ reviewItem?.message }}
              </div>
              }
              <!-- Labels for flags -->
              @if (reviewItem.type === 'flag') {
              <div class="ui label">
                {{ reviewItem.message }}
              </div>
              } @if (reviewItem.parentComment) {
              <div class="commenter-name">
                {{ reviewItem.parentComment?.author }}
              </div>
              } @if (reviewItem.type !== 'comment') {
              <div
                [ngClass]="{
                  'warning-date': reviewItem.type === 'warning',
                  date: reviewItem.type === 'flag'
                }"
              >
                {{ reviewItem.createdAtString }}
              </div>
              }
            </div>
            <!-- Labels for comments, flags -->
            @if (reviewItem.type !== 'warning') {
            <div>
              @if (reviewItem.type === 'comment') {
              <div class="commenter-name">{{ reviewItem?.author }}</div>
              }
              <div class="commenter-role">
                <div>
                  <i
                    class="small circle icon"
                    [ngClass]="{
                      preparer: reviewItem?.role === 'Preparer',
                      reviewer: reviewItem?.role === 'Reviewer'
                    }"
                  ></i>
                  {{ reviewItem?.role }}
                </div>
                @if (reviewItem.type === 'comment') {
                <div class="comment-date">
                  {{ reviewItem?.createdAtString }}
                </div>
                }
              </div>
            </div>
            }
            <!-- Question labels for Flags, warnings -->
            @if (reviewItem.type !== 'comment') {
            <div class="labels">
              @for (question of reviewItem?.questions; track question) {
              <div
                class="ui label"
                (click)="
                  setfocusOnQuestion(
                    question?.questionId,
                    reviewItem?.type,
                    question?.answerId
                  )
                "
              >
                @if (showQuestionId) {
                <span>{{ question?.questionId }}.</span>
                }
                {{ question?.name }}
                @if (question?.rowIndex && reviewItem?.type === 'warning') {
                <span> (row - {{ question?.rowIndex }}) </span>
                }
              </div>
              }
            </div>
            }

            @if (reviewItem.type === 'warning') {
              <pre class="warning-message">{{ reviewItem?.warningMessage }}</pre>
            }
            <!-- Question labels for Comments -->
            @if (reviewItem.type === 'comment') {
            <div class="labels">
              @for (question of reviewItem?.questions; track question) {
              <div
                class="ui label label-comment"
                [matTooltip]="question.tooltipContent"
                matTooltipPosition="above"
                (click)="
                  setfocusOnQuestion(
                    question?.questionId,
                    reviewItem?.type,
                    question?.answerId
                  )
                "
              >
                @if (showQuestionId) {
                <span>{{ question?.questionId }}.</span>
                }
                {{ question?.name }}
                @if (question?.rowIndex && reviewItem?.type === 'warning') {
                <span> (row - {{ question?.rowIndex }}) </span>
                }
              </div>
              }
            </div>
            }
            <!-- Comment text for comments -->
            @if (reviewItem.type === 'comment') {
            <div class="comment-text">
              <app-comment
                [comment]="reviewItem?.comment"
                [documents]="taxReturn.documents"
                (imgClick)="setModal($event)"
              ></app-comment>
            </div>
            } @if (reviewItem.parentComment) {
            <div class="comment-text">
              <app-comment
                [comment]="reviewItem.parentComment"
                [documents]="taxReturn.documents"
                (imgClick)="setModal($event)"
              ></app-comment>
            </div>
            } @for (comment of reviewItem.replies; track comment) {
            <div class="reply comment">
              <div class="header">
                <div class="commenter-name">{{ comment?.author }}</div>
                <!-- Warning and flag dates are formatted level with the name -->
                @if (reviewItem.type !== 'comment') {
                <div
                  [ngClass]="{
                    'warning-date': reviewItem.type === 'warning',
                    date: reviewItem.type === 'flag'
                  }"
                >
                  {{ comment?.date }}
                </div>
                }
              </div>
              <div class="commenter-role">
                <div>
                  <i
                    class="small circle icon"
                    [ngClass]="{
                      preparer: comment?.role === 'Preparer',
                      reviewer: comment?.role === 'Reviewer'
                    }"
                  >
                  </i>
                  {{ comment?.role }}
                </div>
                <!-- Comment dates are formatted level with the role -->
                @if (reviewItem.type === 'comment') {
                <div class="comment-date">{{ comment?.date }}</div>
                }
              </div>
              <div class="comment-labels"></div>
              <div class="comment-text">
                <app-comment
                  [comment]="comment"
                  [documents]="taxReturn.documents"
                  (imgClick)="setModal($event)"
                ></app-comment>
              </div>
            </div>
            } @if (reviewItem?.comment?.replyTo) {
            <div class="reply-comment">
              <app-attachments
                [(ngModel)]="reviewItem.comment.replyComment"
                (setModal)="setModal($event)"
              ></app-attachments>
              <span
                (click)="cancelReply(reviewItem.comment)"
                class="cancel-reply"
                >{{ "taxReturns.cancel" | transloco }}</span
              >
              <div
                (click)="saveCommentReply(reviewItem?.comment, reviewItem)"
                class="ui primary background button"
                [ngClass]="{
                  disabled: !reviewItem?.comment.replyComment.message,
                  loading: isSavingReply
                }"
              >
                {{ "taxReturns.post" | transloco }}
              </div>
            </div>
            } @if (reviewItem?.type === 'comment' &&
            !reviewItem.comment.readonly && !reviewItem.comment.replyTo) {
            <span
              class="reply-btn"
              [class.disabled]="false"
              (click)="reviewItem.comment.replyTo = true"
              >{{ "taxReturns.reply" | transloco }}
            </span>
            }
          </div>
          }
        </div>
      </div>
      } @if (tab === 2 && getCommentMeta) {
      <app-comments
        [comment]="comment"
        [comments]="comments"
        (setModal)="setModal($event)"
        (commentSave)="saveComment($event)"
        (commentReply)="updateCommentsCount($event)"
        (totalComments)="updateGroupCommentsCount($event)"
        [activeGroup]="activeGroup"
        [activeSubgroup]="activeGroup.activeSubGroup"
        [subCategory]="subCategory"
        [documents]="taxReturn.documents"
        [isSaving]="isSaving"
        [commentFields]="commentFields"
        [getCommentMeta]="getCommentMeta"
        [handlePostCommentReply]="pushComments"
        [readonly]="readonly()"
        [pastedDocMetadatas]="commentDocumentMetadatas"
        (deleteCommentField)="deleteCommentField($event)"
        (focusOnQuestion)="setfocusOnQuestionChildComp($event)"
        [rootFolder]="taxReturn.docshareRootFolder"
      >
      </app-comments>
      }
    </div>
    }
  </aside>
</div>
@if (hasGroupings) {
<div>
  <div #editGroupModal id="edit-group-modal" class="ui tiny modal">
    <div class="modal-close close icon"></div>
    <h1>{{ "taxReturns.edit" | transloco }}</h1>
    @for (group of subCategory?.groups; track group) { @if (group.formGroup) {
    <div [hidden]="group?.id !== activeGroup?.id">
      <div class="content">
        <app-form-field-wrapper
          [formGroup]="group.formGroup"
          [groupId]="group?.id"
          [question]="group?.question"
          [disabled]="readonly()"
        ></app-form-field-wrapper>
      </div>
      <div class="actions">
        <span class="go-back cancel">{{
          "taxReturns.cancel" | transloco
        }}</span>
        <div
          class="ui primary background button approve"
          [ngClass]="{
            disabled:
              !(group.formGroup?.controls)[group?.question?.id]?.valid ||
              !(group.formGroup?.controls)[group?.question?.id]?.value
          }"
        >
          {{ "taxReturns.ok" | transloco }}
        </div>
      </div>
    </div>
    } }
  </div>
  <div #addGroupModal id="add-group-modal" class="ui tiny modal">
    <div class="modal-close close icon"></div>
    <h1>{{ "taxReturns.add-new-item" | transloco }}</h1>
    <div class="content">
      @if (activeGroup?.question) {
      <app-form-field-wrapper
        [groupId]="newGroupId"
        [formGroup]="newGroupFormGroup"
        [question]="activeGroup?.question"
        [disabled]="readonly()"
      ></app-form-field-wrapper>
      }
    </div>
    <div class="actions">
      <span class="go-back cancel">{{ "taxReturns.cancel" | transloco }}</span>
      <div
        class="ui primary background button approve"
        [ngClass]="{
          disabled:
            !newGroupFormGroup?.valid ||
            !newGroupFormGroup.controls[activeGroup?.question?.id]?.value,
          loading: isSaving
        }"
      >
        {{ "taxReturns.add" | transloco }}
      </div>
    </div>
  </div>
  <div #deleteGroupModal id="delete-group-modal" class="ui tiny modal">
    <div class="modal-close close icon"></div>
    <h1>{{ "taxReturns.are-you-sure" | transloco }}</h1>
    <div class="content">
      {{ "taxReturns.are-you-sure-you-want-to-delete" | transloco }}
      <strong>{{
        (groupToDelete?.formGroup?.controls)[groupToDelete?.question?.id]?.value
      }}</strong
      >{{
        "taxReturns.the-data-will-be-deleted-from-the-system-and-you-will-not-be-able-to-retrieve-it"
          | transloco
      }}
    </div>
    <div class="actions">
      <span class="go-back cancel">{{
        "taxReturns.no-cancel" | transloco
      }}</span>
      <div
        class="ui primary background button approve"
        [ngClass]="{ loading: isSaving }"
      >
        {{ "taxReturns.yes-delete" | transloco }}
      </div>
    </div>
  </div>
</div>
} }

<div #saveModal id="save-modal" class="ui tiny modal">
  <div class="modal-close close icon"></div>

  <h1>{{ "taxReturns.save" | transloco }}</h1>

  <div class="content">
    <p>
      {{
        "taxReturns.you-have-edited-fields-please-make-sure-your-comment-is-finished-before-you-save"
          | transloco
      }}
    </p>

    @for (field of commentFields; track field) {
    <div class="ui label">
      {{ field?.question }} ({{ field?.groupName }}
      @if (field?.groupName && field?.subGroupName) {
      <span>-</span>
      }
      {{ field?.subGroupName }}@if (field?.rowIndex != null) {
      <span> - row {{ field?.rowIndex + 1 }}</span>
      })
    </div>
    }

    <app-attachments
      id="comment-textbox"
      [formControl]="comment"
    ></app-attachments>
  </div>

  <div class="actions">
    <span class="go-back deny">{{ "taxReturns.no-go-back" | transloco }}</span>

    <div
      class="ui primary background button"
      (click)="save()"
      [ngClass]="{ disabled: !comment.value, loading: isSaving }"
    >
      {{ "taxReturns.save-and-post" | transloco }}
    </div>
  </div>
</div>

<div #clearOverridesModal id="save-modal" class="ui tiny modal">
  <div class="modal-close close icon"></div>

  <h1>{{ "taxReturns.clear-overrides-modal" | transloco }}</h1>

  <div class="content">
    <p>
      {{ clearOverrideModalMessage }}
    </p>
  </div>

  @if (!isClearingOverrides) {
  <div class="actions">
    <div
      class="ui primary approve background button"
      [ngClass]="{ loading: isClearingOverrides }"
    >
      {{ "yes" | transloco }}
    </div>
    <div class="ui primary deny background button">
      {{ "taxReturns.no-go-back" | transloco }}
    </div>
  </div>
  } @if (isClearingOverrides) {
  <div class="actions">
    <div class="ui primary deny background button">
      {{ "close" | transloco }}
    </div>
  </div>
  }
</div>

<div #calcResultsModal id="calc-results-modal" class="ui tiny modal">
  @if (!isRunningCalcs) {
  <div class="modal-close close icon"></div>
  } @if (isRunningCalcs) {
  <h1>{{ "taxReturns.processing-calculation" | transloco }}</h1>
  } @if (!isRunningCalcs) {
  <h1>{{ "taxReturns.finished-calculation" | transloco }}</h1>
  }

  <div class="content">
    @for (line of calcResultsSummary; track line) {
    <p>
      {{ line }}
    </p>
    } @if (!showCalcDebug) {
    <ol>
      @for (f of calcFailures; track f) {
      <li>{{ f }}</li>
      }
    </ol>
    } @if (showCalcDebug) {
    <span>
      <table>
        <thead>
          <tr>
            <th>{{ "taxReturns.question-id" | transloco }}</th>
            <th>{{ "taxReturns.execution-time-ns" | transloco }}</th>
            <th>{{ "taxReturns.trace-time-ns" | transloco }}</th>
            <th>{{ "taxReturns.has-failed-input" | transloco }}</th>
            <th>{{ "taxReturns.skip-trace-creation" | transloco }}</th>
          </tr>
        </thead>
        <tbody>
          @for (q of calcDebug; track q) {
          <tr>
            <td>{{ q.questionId }}</td>
            <td>{{ q.exec / 1000000 | number }}</td>
            <td>{{ q.traceTime / 1000000 | number }}</td>
            <td>{{ q.failedInput }}</td>
            <td>{{ q.skipTrace }}</td>
          </tr>
          }
        </tbody>
      </table>
    </span>
    }
  </div>

  <div class="actions">
    @if (isAdmin) {
    <div class="ui primary background button" (click)="toggleCalcDebug()">
      {{ "taxReturns.toggle-calc-debug" | transloco }}
    </div>
    } @if (!isRunningCalcs) {
    <div
      class="ui primary background button approve"
      (click)="clearCalcsResults()"
    >
      {{ "taxReturns.ok" | transloco }}
    </div>
    }
  </div>
</div>

<div #bulkReplyModal id="bulk-reply-modal" class="ui tiny modal">
  <div class="modal-close close icon"></div>

  <h1>Reply to Multiple Warnings</h1>

  <div class="content">
    <p>Do you want to post comments for all warnings?</p>
  </div>

  <div class="actions">
    <div
      (click)="handleYesClick()"
      class="ui primary background button approve"
    >
      Yes
    </div>
    <div (click)="handleNoClick()" class="ui primary background button deny">
      No
    </div>
  </div>
</div>
<div #unsavedModal id="unsaved-modal" class="ui tiny modal">
  <div class="modal-close close icon"></div>

  <h1>{{ "taxReturns.warning" | transloco }}</h1>

  <div class="content">
    <p>{{ "taxReturns.unsaved-manual-inputs" | transloco }}</p>
  </div>

  <div class="actions">
    <div
      class="ui primary background button approve"
      [ngClass]="{ loading: isSaving }"
      (click)="saveCheckEdits()"
    >
      {{ "taxReturns.save" | transloco }}
    </div>
    <div class="ui primary background button approve" (click)="doNotSave()">
      {{ "taxReturns.do-not-save" | transloco }}
    </div>
    <div class="ui primary background button approve deny">
      {{ "taxReturns.cancel" | transloco }}
    </div>
  </div>
</div>

<div #unsavedFieldsModal id="unsaved-fields-modal" class="ui tiny modal">
  <div class="modal-close close icon"></div>

  <h1>{{ "taxReturns.hold-on" | transloco }}</h1>

  <div class="content">
    <p>
      {{
        "taxReturns.you-have-unsaved-changes-please-save-your-changes-before-posting-flags"
          | transloco
      }}
    </p>

    @for (field of commentFields; track field) {
    <div class="ui label">
      {{ field?.question }} ({{ field?.groupName }}
      @if (field?.groupName && field?.subGroupName) {
      <span>-</span>
      }
      {{ field?.subGroupName }}@if (field?.rowIndex != null) {
      <span> - row {{ field?.rowIndex + 1 }}</span>
      })
    </div>
    }
  </div>

  <div class="actions">
    <div
      class="ui primary background button approve"
      [ngClass]="{ loading: isSaving }"
    >
      OK
    </div>
  </div>
</div>

<div #answerWarningsModal id="answer-warnings-modal" class="ui tiny modal">
  <h1>{{ "taxReturns.close-warnings" | transloco }}</h1>

  <div class="content">
    <p>
      {{
        "taxReturns.you-have-updated-answer-s-which-contain-a-warning-do-you-want-to-close-the-warning-for-the-following-answers"
          | transloco
      }}
    </p>
    <div>
      @for (ansWarning of savedAnswersWithWarnings; track ansWarning) {
      <div class="ui label">
        {{ ansWarning?.question }}
      </div>
      }
    </div>
  </div>

  <div class="actions">
    <span class="go-back cancel">{{ "taxReturns.no" | transloco }}</span>
    <div class="ui primary background approve button">
      {{ "taxReturns.yes-close-warnings" | transloco }}
    </div>
  </div>
</div>

<div #answerFlagsModal id="answer-flags-modal" class="ui tiny modal">
  <h1>{{ "taxReturns.close-flags" | transloco }}</h1>

  <div class="content">
    <p>
      {{
        "taxReturns.you-have-updated-answer-s-which-have-been-flagged-do-you-want-to-close-the-flag-for-the-following-answers"
          | transloco
      }}
    </p>
    <div>
      @for (ansFlag of savedAnswersWithFlags; track ansFlag) {
      <div class="ui label">
        {{ ansFlag.question?.question }} ({{ ansFlag.groupName }}
        @if (ansFlag.groupName && ansFlag.subGroupName) {
        <span>-</span>
        }
        {{ ansFlag.subGroupName }}@if (ansFlag.rowIndex != null) {
        <span
          >{{ "taxReturns.row" | transloco }} {{ ansFlag.rowIndex + 1 }}</span
        >
        })
      </div>
      }
    </div>
  </div>

  <div class="actions">
    <span class="go-back cancel">{{ "taxReturns.no" | transloco }}</span>
    <div class="ui primary background approve button">
      {{ "taxReturns.yes-close-flags" | transloco }}
    </div>
  </div>
</div>

<div #notesModal class="ui modal subcategory notes">
  <div class="modal-close close icon"></div>
  @if (subCategory && taxReturn) {
  <app-notes
    [assignee]="taxReturn.assignee"
    [taxReturn]="taxReturn"
    [subcategoryId]="subCategory.id"
    (noteAddedEmit)="updateNotesCount($event)"
    [setModal]="setModal.bind(this)"
  ></app-notes>
  }
</div>

<div #singleAnswerOverRideModal id="save-modal" class="ui tiny modal">
  <div class="modal-close close icon"></div>

  <h1>{{ "taxReturns.single-answer-deletion" | transloco }}</h1>

  <div class="content">
    <p>
      {{ "taxReturns.single-answer-deletion-modal-content" | transloco }}
    </p>
  </div>

  <div class="actions">
    <div class="ui checkbox">
      <label>{{
        "taxReturns.single-answer-deletion-do-not-display-popup" | transloco
      }}</label>
      <input
        type="checkbox"
        (change)="toggleSingleAnswerModalOpenState($event)"
      />
    </div>

    <div class="ui primary background button approve">
      {{ "taxReturns.close" | transloco }}
    </div>
  </div>
</div>

@if (modalImgSrc) {
<div class="modal-backdrop" (click)="setModal()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <img [src]="modalImgSrc" />
  </div>
</div>
} @if (!isReady) {
<div class="ui active inverted dimmer" [ngClass]="{ dimmed: !firstLoad }">
  <div class="ui large text loader">{{ "taxReturns.loading" | transloco }}</div>
</div>
}
